import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/modern/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full border font-normal transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 leading-none text-base leading-none justify-center items-center",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary !text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80 ",
        muted: " bg-background text-muted-foreground border ",
        accent: "border-transparent bg-accent text-accent-foreground hover:bg-accent/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        "destructive-outline": "border-destructive bg-destructive/5 hover:bg-destructive/10 !text-destructive",
        outline: "border border-border text-foreground",
        success: "border-transparent bg-success !text-success-foreground hover:bg-success/5",
        "success-outline": "border-success bg-success/5 !text-success",
        degraded: "border-transparent bg-degraded !text-degraded-foreground hover:bg-degraded/90",
        "degraded-outline": "border-degraded bg-degraded/5 !text-degraded",
        ai: "border-transparent bg-ai !text-ai-foreground hover:bg-ai/90",
        "ai-outline": "border-ai bg-ai/5 !text-ai",
        "primary-inverted": "border-transparent bg-primary-foreground !text-primary shadow-sm",
        "primary-outline": "border-primary/70 bg-primary/5 hover:bg-primary/10",
        "primary-gradient": "bg-gradient-to-r from-primary/20 to-primary/10  text-primary-foreground"
      },
      size: {
        xs: "w-6 h-6 min-w-6 min-h-6 p-0 text-xs aspect-square",
        sm: "px-2 py-1 text-swivu-sm",
        md: "px-3 py-1",
        lg: "px-4 py-2"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "md"
    }
  }
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant, size }), className)} {...props} />;
}

export { Badge, badgeVariants };
